export const TextModuleMock = {
  uid: "59fe4667-40c5-4194-a989-13feda8fbf3b",
  componentName: "TextModule",
  dataSource: "{DEEC6F37-FAAA-4B7D-B14A-35C42E163E5C}",
  params: {
    textPosition: "center",
    backgroundColor: "grey",
  },
  fields: {
    BodyText: {
      value:
        "<span>Sed ut perspiciatis unde omnis <a>iste natus error sit</a> voluptatem accusantium doloremque laudantium. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum., <b>totam rem aperiam</b>:</span>",
    },
    Eyebrow: {
      value: "OPTIONAL EYEBROW",
    },
    Title: {
      value: "Main title here",
    },
    Subtitle: {
      value:
        "Find loader attachments that are compatible with your high horsepower , all-purpose or compact tractors for a variety of material handling chores.",
    },
    PrimaryLink: {
      value: {
        href: "",
        text: "Optional Primary CTA",
        linktype: "external",
        url: "",
        anchor: "",
        target: "",
      },
    },
    SecondaryLink: {
      value: {
        href: "",
        text: "Optional Secondary CTA",
        linktype: "external",
        url: "",
        anchor: "",
        target: "",
      },
    },
    Image: {
      value: {
        src: "http://localhost:8085/images/split-module/pic-16-9-generic-image.png",
        alt: "icon",
        width: "32",
        height: "32",
      },
    },
    "Background Color": {
      fields: {
        Key: {
          value: "grey",
        },
        Phrase: {
          value: "",
        },
      },
    },
    Alignment: {
      id: "2f1265bd-c7c3-4fe2-9b46-5d580fadb2aa",
      url: "/sitecore/system/Settings/Project/corporateI/Settings/Alignment/Center",
      fields: {
        Key: {
          value: "left",
        },
        Phrase: {
          value: "",
        },
      },
    },
  },
}
